import { useQuery } from '@tanstack/react-query';
import { apiClient } from './client';

export interface DashboardStats {
  total_projects: number;
  total_cabinets: number;
  materials_in_library: number;
  hardware_in_library: number;
  cabinet_templates: number;
  status_breakdown: Record<string, number>;
  recent_projects: Array<{
    id: string;
    project_name: string;
    client_name: string;
    status: string;
    updated_at: string;
  }>;
}

export function useDashboardStats() {
  return useQuery({
    queryKey: ['dashboard', 'stats'],
    queryFn: async () => {
      const { data } = await apiClient.get<DashboardStats>('/dashboard/stats');
      return data;
    },
  });
}
